import { useContext, useState } from 'react'
import { AnimatePresence, motion, useMotionValue } from 'motion/react'
import { useNavigate } from 'react-router-dom'
import { useSelectedMenuStore } from 'store'
import { MeContext } from 'contexts/me'
import { trackEvent } from 'analytics/trackFunctions'
import { hasActiveMembership, hasSuspendedMembership } from 'utils'
import LogoutModal from 'components/LogoutModal'
import UserCard from 'components/UserCard'
import { LOGOUT_BUTTON, MEMBERSHIP_BUTTON, SECONDARY_NAV } from './menus'

import MenuButton from './MenuButton'

const MobileMenu = ({ isOpen, setOpen }) => {
  const [isLogoutOpen, setLogoutOpen] = useState<boolean>(false)
  const { updateSelectedMenu } = useSelectedMenuStore()
  const { me } = useContext(MeContext)
  const navigate = useNavigate()
  const overflow = useMotionValue('scroll')

  const modalVariants = {
    hidden: {
      height: 0,
      y: '200vh'
    },
    visible: {
      height: '100%',
      y: 0,
      transition: {
        ease: 'easeInOut'
      }
    },
    exit: {
      y: '100vh',
      transition: {
        ease: 'easeInOut',
        delay: 0.1
      }
    }
  }

  const iconClass = 'max-w-full w-6 h-auto'

  const membershipButtonDescription = () => {
    if (hasActiveMembership(me?.subscriber_products)) {
      return '¡Estás al día con tu membresía!'
    }
    if (hasSuspendedMembership(me?.subscriber_products)) {
      return 'Pagá y disfrutá de los beneficios'
    }
    return null
  }

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <motion.nav
            className='z-60 md:hidden fixed top-0 inset-0'
            variants={modalVariants}
            onAnimationStart={() => overflow.set('hidden')}
            animate='visible'
            initial='hidden'
            exit='exit'
          >
            <div
              className='fixed top-0 w-full h-full bg-white'
              aria-hidden='true'
            >
              <UserCard
                mobileMenu
                className='py-3 !justify-start px-4 bg-gray-100'
              />

              <hr className='h-[1px] w-full bg-gray-500 my-3' />

              <MenuButton
                isMobile
                isMembership
                selected={false}
                label={MEMBERSHIP_BUTTON.text}
                subLabel={membershipButtonDescription()}
                icon={<MEMBERSHIP_BUTTON.Icon className={iconClass} />}
                extended
                onClick={() => {
                  updateSelectedMenu(MEMBERSHIP_BUTTON.id)
                  navigate(`/${MEMBERSHIP_BUTTON.id}`)
                  setOpen(false)
                }}
              />

              <hr className='h-[1px] w-full bg-gray-500 my-3' />

              <div
                className={`flex flex-col gap-2 ${
                  !isOpen && 'overflow-hidden'
                }`}
              >
                {SECONDARY_NAV.map((b) => (
                  <MenuButton
                    key={b.text}
                    isMobile
                    selected={false}
                    label={b.text}
                    icon={
                      <b.Icon
                        className={`${iconClass} ${
                          b.id === 'cvu' ? 'fill-green-800' : 'stroke-green-800'
                        }`}
                      />
                    }
                    extended
                    onClick={() => {
                      if (b.event) trackEvent({ eventName: b.event })
                      updateSelectedMenu(b.id)
                      navigate(`/${b.id}`)
                      setOpen(false)
                    }}
                  />
                ))}
              </div>

              <hr className='h-[1px] w-full bg-gray-500 my-3' />

              <MenuButton
                isMobile
                selected={false}
                label={LOGOUT_BUTTON.text}
                icon={<LOGOUT_BUTTON.Icon className={iconClass} />}
                extended
                onClick={() => {
                  setLogoutOpen(true)
                  setOpen(false)
                }}
              />
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
      <LogoutModal isOpen={isLogoutOpen} setIsOpen={setLogoutOpen} />
    </>
  )
}

export default MobileMenu
